export function formatOrderType(item: any) {
  switch (item) {
    case "MARKET":
      return "Market";
    case "LIMIT":
      return "Limit";
    case "STOP":
      return "Stop";
    case "STOPLIMIT":
      return "Stop Limit";
    /*
     * IREBALUX-1338
     * Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
     */
    case "TRAILING_STOP_PRC":
      return "Trailing Stop %";
    case "TRAILING_STOP_DOLLAR":
      return "Trailing Stop $";

    default:
      return item;
  }
}
export function formatOrderTypeReverse(item: any) {
  switch (item) {
    case "Market":
      return "MARKET";
    case "Limit":
      return "LIMIT";
    case "Stop":
      return "STOP";
    case "Stop Limit":
      return "STOPLIMIT";
    /*
     * IREBALUX-1338
     * Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
     */
    case "Trailing Stop %":
      return "TRAILING_STOP_PRC";
    case "Trailing Stop $":
      return "TRAILING_STOP_DOLLAR";

    default:
      return item;
  }
}
export function formatTransactionAction(item: string) {
  switch(item)
  {
    case "BUY" : return "Generate buy trades only";
    case "SELL" : return "Generate sell trades only";
    case "BUY_SELL" : return "Generate both buy/ sell trades";
    case "NONE" : return "No trade";
    default: return item;
  }
}

export function formatOrderStatus(item: string) {
  switch (item) {
    case 'REPLACE_REQUESTED':
      return 'Replace requested';
    case 'REPLACE_WARNING':
      return 'Replace warning';
    case 'CANCELLED_WITH_NO_FILL':
      return 'Canceled - no fill';
    case 'CANCELLED_WITH_PARTIAL_FILL':
      return 'Canceled - partial fill';
    case 'CANCEL_REJECTED':
      return 'Cancel rejected';
    case 'CANCELLED':
      return 'Canceled';
    case 'FILLED':
      return 'Filled';
    case 'PARTIALLY_FILLED':
      return 'Partially filled';
    case 'APPROVED':
      return 'Approved';
    case 'SUBMITTED_TO_VEO':
      return 'Submitted';
    case 'CANCEL_REQUESTED':
      return 'Cancel requested';
    case 'ON_HOLD':
      return 'On hold';
    case 'MARK_AS_EXECUTED':
      return 'Marked as executed';
    case 'REJECTED':
      return 'Rejected';
    case 'MANUALLY_SUBMITTED':
      return 'Manually submitted';
    case 'PENDING_VALIDATION':
      return 'Pending validation';
    case 'VALIDATED':
      return 'Validated';
    case 'WARNING':
      return 'Warning';
    case 'ERROR':
      return 'Error';
    case 'OVERRIDDEN':
      return 'Overridden';
    case 'ALL':
      return 'All';
    case 'ALLOCATIONS_SENT':
      return 'Allocations sent';
    case 'ALLOCATIONS_FAILED':
      return 'Allocations failed';
    case 'MANUALLY_ALLOCATED':
      return 'Manually allocated';
    case 'EQUITY':
      return 'Equity';
    case 'MUTUAL_FUND':
      return 'Mutual Fund';
    case 'OPTION':
      return 'Option';
    case 'CASH':
      return 'Cash';
    case 'BOND':
      return 'Bond';
    case 'SMA':
      return 'SMA';
    case 'GROUP':
      return 'Group';
    case 'OTHER':
      return 'Other';
    case 'MARK_AS_CANCELED':
      return 'Mark as Canceled';
    case 'EXPORTED_TO_THINK_PIPES':
      return 'Exported to ThinkPipes';
    default:
      return item;
  }
}
export function formatOrderStatusReverse(item: string) {
  switch (item) {
    case 'Replace requested':
      return 'REPLACE_REQUESTED';
    case 'Replace warning':
      return 'REPLACE_WARNING';
    case 'Canceled - no fill':
      return 'CANCELLED_WITH_NO_FILL';
    case 'Canceled - partial fill':
      return 'CANCELLED_WITH_PARTIAL_FILL';
    case 'Cancel rejected':
      return 'CANCEL_REJECTED';
    case 'Canceled':
      return 'CANCELLED';
    case 'Filled':
      return 'FILLED';
    case 'Partially filled':
      return 'PARTIALLY_FILLED';
    case 'Approved':
      return 'APPROVED';
    case 'Submitted':
      return 'SUBMITTED_TO_VEO';
    case 'Cancel requested':
      return 'CANCEL_REQUESTED';
    case 'On hold':
      return 'ON_HOLD';
    case 'Marked as executed':
      return 'MARK_AS_EXECUTED';
    case 'Rejected':
      return 'REJECTED';
    case 'Manually submitted':
      return 'MANUALLY_SUBMITTED';
    case 'Pending validation':
      return 'PENDING_VALIDATION';
    case 'Validated':
      return 'VALIDATED';
    case 'Warning':
      return 'WARNING';
    case 'Error':
      return 'ERROR';
    case 'Overridden':
      return 'OVERRIDDEN';
    case 'All':
      return 'ALL';
    case 'Allocations sent':
      return 'ALLOCATIONS_SENT';
    case 'Allocations failed':
      return 'ALLOCATIONS_FAILED';
    case 'Manually allocated':
      return 'MANUALLY_ALLOCATED';
    case 'Equity':
      return 'EQUITY';
    case 'Mutual Fund':
      return 'MUTUAL_FUND';
    case 'Option':
      return 'OPTION';
    case 'Cash':
      return 'CASH';
    case 'Bond':
      return 'BOND';
    case 'SMA':
      return 'SMA';
    case 'Group':
      return 'GROUP';
    case 'Other':
      return 'OTHER';
    case 'Mark as Canceled':
      return 'MARK_AS_CANCELED';
    case 'Exported to ThinkPipes':
      return 'EXPORTED_TO_THINK_PIPES';
    default:
      return item;
  }
}

export function formatTransaction(item: string) {
  switch (item) {
    case 'BUY':
      return 'Buy';
    case 'SELL':
      return 'Sell';
    case 'SELL_ALL':
      return 'Sell All';
    case 'SWAPEXCHANGE':
      return 'Swap/Exchange';
    case 'SWAP':
      return 'Swap';
    case 'SWAP_ALL':
      return 'Swap All';
    case 'EXCHANGE':
      return 'Exch';
    case 'EXCHANGE_ALL':
      return 'Exch All';
    case 'SELL_TO_OPEN':
      return 'Sell to open';
    case 'SELL_TO_CLOSE':
      return 'Sell to close';
    case 'BUY_TO_OPEN':
      return 'Buy to open';
    case 'BUY_TO_CLOSE':
      return 'Buy to close';
    case 'SPREAD':
      return 'Spread';
    default:
      return item;
  }
}

export function formatTransactionReverse(item: string) {
  switch (item) {
    case 'Buy':
      return 'BUY';
    case 'Sell':
      return 'SELL';
    case 'Sell All':
      return 'SELL_ALL';
    case 'Swap/Exchange':
      return 'SWAPEXCHANGE';
    case 'Swap':
      return 'SWAP';
    case 'Swap All':
      return 'SWAP_ALL';
    case 'Exch':
      return 'EXCHANGE';
    case 'Exch All':
      return 'EXCHANGE_ALL';
    case 'Sell to open':
      return 'SELL_TO_OPEN';
    case 'Sell to close':
      return 'SELL_TO_CLOSE';
    case 'Buy to open':
      return 'BUY_TO_OPEN';
    case 'Buy to close':
      return 'BUY_TO_CLOSE';
    case 'Spread':
      return 'SPREAD';
    default:
      return item;
  }
}
export function formatExpTypes(item: string) {
  switch (item) {
    case 'DAY':
      return 'Day';
    case 'DAYEXT':
      return 'Day ext';
    case 'EXTAM':
      return 'Ext. AM';
    case 'EXTPM':
      return 'Ext. PM';
    case 'GT6M':
      return 'GT6m';
    case 'GTD':
      return 'GTD';
    case 'GTDEXT':
      return 'GTD Ext';
    case 'MOC':
      return 'MoC';
    default:
      return item;
  }
}

export function formatExpTypesReverse(item: string) {
  switch (item) {
    case 'Day':
      return 'DAY';
    case 'Day Ext':
      return 'DAYEXT';
    case 'Ext. AM':
      return 'EXTAM';
    case 'Ext. PM':
      return 'EXTPM';
    case 'GT6m':
      return 'GT6M';
    case 'GTD':
      return 'GTD';
    case 'GTD Ext':
      return 'GTDEXT';
    case 'MoC':
      return 'MOC';
    case 'Market On Close':
      return 'MOC'
    default:
      return item;
  }
}
export function formatExpTypesForUpdate(item: string) {
  switch (item) {
    case 'DAY':
      return 'Day';
    case 'DAYEXT':
      return 'Day Ext';
    case 'EXTAM':
      return 'Ext. AM';
    case 'EXTPM':
      return 'Ext. PM';
    case 'GT6M':
      return 'GT6M';
    case 'GTD':
      return 'GTD';
    case 'GTDEXT':
      return 'GTD Ext';
    case 'MOC':
      return 'Market On Close';
    default:
      return item;
  }
}
export function formatAlgorithm(item: string) {
  switch (item) {
    case 'PERCENTAGE_OF_VOLUME':
      return 'Percent of Volume';
    case 'SMART_V_TRACK':
      return 'SMART-VTRACK';
    case 'FAN':
      return 'Fan';
    case 'COVERT':
      return 'Covert';
    case 'SUMO':
      return 'Sumo';
    case 'OASIS':
      return 'Oasis';
    case 'ARRIVAL':
      return 'IS (Arrival)';
    default:
      return item;
  }
}
export function formatAlgorithmReverse(item: string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case 'percent of volume':
      return 'PERCENTAGE_OF_VOLUME';
    case 'smart-vtrack':
      return 'SMART_V_TRACK';
    case 'fan':
      return 'FAN';
    case 'covert':
      return 'COVERT';
    case 'sumo':
      return 'SUMO';
    case 'oasis':
      return 'OASIS';
    case 'is (arrival)':
      return 'ARRIVAL';
    default:
      return item;
  }
}
export function formatdefaultOrderPriceType(item: string) {
  switch (item) {
    case 'None':
      return 'Price';
    case 'LASTTRADE':
      return 'Last Trade';
    case 'BID':
      return 'Bid';
    case 'ASK':
      return 'Ask';
    case 'MIDPOINT':
      return 'Midpoint';
    default:
      return item;
  }
}
export function formatdefaultOrderPriceTypeForPayload(item: string) {
  switch (item) {
    case 'None':
      return 'None';
    case 'LASTTRADE':
      return 'Last trade';
    case 'BID':
      return 'Bid';
    case 'ASK':
      return 'Ask';
    case 'MIDPOINT':
      return 'Midpoint';
    default:
      return item;
  }
}
export function formatdefaultOrderPriceTypeReverse(item: string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case 'price':
      return 'None';
    case 'last trade':
      return 'LASTTRADE';
    case 'bid':
      return 'BID';
    case 'ask':
      return 'ASK';
    case 'midpoint':
      return 'MIDPOINT';
    default:
      return item;
  }
}
export function formatSecurityType(item: string) {
  switch (item) {
    case "EQUITY":
      return "Equity";
    case "MUTUAL_FUND":
      return "Mutual fund";
    case "CASH":
      return "Cash";
    case "BOND":
      return "Bond";
    case "SMA":
      return "SMA";
    case "GROUP":
      return "Group";
    case "OTHER":
      return "Other";
    case "ALL":
      return "All";
    case "OPTION":
      return "Option";
    case "EXTERNAL":
      return "External";
    default:
      return item;
  }
}
export function formatSecurityTypeReverse(item: string) {
  const v = item || '';
  switch (v.toLowerCase()) {
	case "equity":
		return "EQUITY";
	case "mutual fund":
		return "MUTUAL_FUND";
	case "cash":
		return "CASH";
	case "bond":
		return "BOND";
	case "sma":
		return "SMA";
	case "group":
		return "GROUP";
	case "other":
		return "OTHER";
	case "all":
		return "ALL";
	case "option":
		return "OPTION";
	case "external":
		return "EXTERNAL";
	default:
		return item;
	}}
export function formatTicketType(item: string) {
  switch (item) {
    case 'E':
      return 'Electronic';
    case 'M':
      return 'Manual'
    case 'A':
      return 'Automated'
    default:
      return item;
  }
}
export function formatOptionTradeType(item: string) {
  switch (item) {
    case "NET_DEBIT":
      return "Debit";
    case "NET_CREDIT":
      return "Credit";
    case "EVEN_MONEY":
        return "EVEN_MONEY";
    default:
      return item;
  }
}
export function formatOptionTradeTypeReverse(item: string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case "debit":
      return "NET_DEBIT";
    case "credit":
      return "NET_CREDIT";
    case "even money":
      return "EVEN_MONEY";
    default:
      return item;
  }
}
export function formatDestinations(item:string) {
  switch (item) {
    case "AOM_PRINTER":
        return "AOM_PRINTER";
    case "VIRTU":
      return "Virtu";
    case "CITADEL":
      return "Citadel";
    default:
      return item;
  }
}
export function formatDestinationsReverse(item:string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case "block desk":
      return "AOM_PRINTER";
    case "virtu":
      return "VIRTU";
    case "citadel":
      return "CITADEL";
    default:
      return item;
  }
}
export function formatFeesOptions(item:string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case "add":
      return "Add";
    case "include":
      return "Include";
    default:
      return item;
  }
}
export function formatFeesOptionsReverse(item:string) {
  const v = item || '';
  switch (v.toLowerCase()) {
    case "add":
      return "ADD";
    case "include":
      return "INCLUDE";
    default:
      return item;
  }
}